// Auto-generated by @fermata/grpc-zustand - DO NOT EDIT
// Generated from: @proto/gen/users/v1/service

import type {
  ActivateCustomerRequest,
  ActivateCustomerResponse,
  CreateCustomerRequest,
  CreateCustomerResponse,
  DeleteCustomerRequest,
  DeleteCustomerResponse,
  GetCustomerRequest,
  GetCustomerResponse,
  ListCustomersRequest,
  ListCustomersResponse,
  UpdateCustomerRequest,
  UpdateCustomerResponse,
} from "@proto/gen/users/v1/service"
import { create } from "zustand"
import { devtools, persist, subscribeWithSelector } from "zustand/middleware"
import { createJSONStorage } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"
import { createMethodState, requestKey } from "../../runtime/middleware"
import { boundedLocalStorage } from "../../runtime/storage"
import type { MethodState } from "../../runtime/types"
import { getCustomerClient } from "./client"

export interface CustomerServiceState {
  /** State for listCustomers method */
  listCustomers: MethodState<ListCustomersResponse>
  /** State for createCustomer method */
  createCustomer: MethodState<CreateCustomerResponse>
  /** State for getCustomer method */
  getCustomer: MethodState<GetCustomerResponse>
  /** State for updateCustomer method */
  updateCustomer: MethodState<UpdateCustomerResponse>
  /** State for deleteCustomer method */
  deleteCustomer: MethodState<DeleteCustomerResponse>
  /** State for activateCustomer method */
  activateCustomer: MethodState<ActivateCustomerResponse>
  /** Call listCustomers method */
  listCustomersAsync: (req: ListCustomersRequest) => Promise<ListCustomersResponse>
  /** Call createCustomer method */
  createCustomerAsync: (req: CreateCustomerRequest) => Promise<CreateCustomerResponse>
  /** Call getCustomer method */
  getCustomerAsync: (req: GetCustomerRequest) => Promise<GetCustomerResponse>
  /** Call updateCustomer method */
  updateCustomerAsync: (req: UpdateCustomerRequest) => Promise<UpdateCustomerResponse>
  /** Call deleteCustomer method */
  deleteCustomerAsync: (req: DeleteCustomerRequest) => Promise<DeleteCustomerResponse>
  /** Call activateCustomer method */
  activateCustomerAsync: (req: ActivateCustomerRequest) => Promise<ActivateCustomerResponse>
}

/**
 * Zustand store for CustomerService
 *
 * Features:
 * - Auto-manages loading/error states per method
 * - Supports fine-grained reactivity with subscribeWithSelector
 * - Optional persistence to localStorage
 * - Redux DevTools integration
 */
export const useCustomerServiceStore = create<CustomerServiceState>()(
  devtools(
    persist(
      subscribeWithSelector(
        immer((set) => ({
          listCustomers: createMethodState<ListCustomersResponse>(),
          async listCustomersAsync(req: ListCustomersRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.listCustomers
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCustomerClient().listCustomers(req)
              set((state) => {
                const slot = state.listCustomers
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.listCustomers
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          createCustomer: createMethodState<CreateCustomerResponse>(),
          async createCustomerAsync(req: CreateCustomerRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.createCustomer
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCustomerClient().createCustomer(req)
              set((state) => {
                const slot = state.createCustomer
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.createCustomer
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          getCustomer: createMethodState<GetCustomerResponse>(),
          async getCustomerAsync(req: GetCustomerRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.getCustomer
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCustomerClient().getCustomer(req)
              set((state) => {
                const slot = state.getCustomer
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.getCustomer
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          updateCustomer: createMethodState<UpdateCustomerResponse>(),
          async updateCustomerAsync(req: UpdateCustomerRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.updateCustomer
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCustomerClient().updateCustomer(req)
              set((state) => {
                const slot = state.updateCustomer
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.updateCustomer
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          deleteCustomer: createMethodState<DeleteCustomerResponse>(),
          async deleteCustomerAsync(req: DeleteCustomerRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.deleteCustomer
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCustomerClient().deleteCustomer(req)
              set((state) => {
                const slot = state.deleteCustomer
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.deleteCustomer
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
          activateCustomer: createMethodState<ActivateCustomerResponse>(),
          async activateCustomerAsync(req: ActivateCustomerRequest) {
            const key = requestKey(req)
            set((state) => {
              const slot = state.activateCustomer
              if (!slot.byKey) slot.byKey = {}
              slot.loading = true
              slot.error = undefined
              const prev = slot.byKey[key]
              slot.byKey[key] = { data: prev?.data, loading: true, error: undefined }
            })
            try {
              const { response } = await getCustomerClient().activateCustomer(req)
              set((state) => {
                const slot = state.activateCustomer
                slot.data = response
                slot.loading = false
                slot.error = undefined
                slot.byKey[key] = { data: response, loading: false, error: undefined }
              })
              return response
            } catch (error) {
              // gRPC-Web percent-encodes the grpc-message trailer per spec; decode it so
              // callers see human-readable text (e.g. "Not found" not "Not%20found").
              if (error instanceof Error) {
                try {
                  error.message = decodeURIComponent(error.message)
                } catch {
                  /* ignore */
                }
              }
              set((state) => {
                const slot = state.activateCustomer
                slot.error = error as Error
                slot.loading = false
                const prev = slot.byKey[key]
                slot.byKey[key] = { data: prev?.data, loading: false, error: error as Error }
              })
              throw error
            }
          },
        }))
      ),
      {
        name: "customer-store",
        // Bounded, non-throwing localStorage (see runtime/storage.ts): an
        // oversized or failing cache write is dropped rather than surfaced,
        // so it can never abort an unrelated store action.
        storage: createJSONStorage(() => boundedLocalStorage, {
          replacer: (key, value) => {
            // Convert BigInt to string for JSON serialization
            if (typeof value === "bigint") {
              return value.toString()
            }
            return value
          },
          reviver: (key, value) => {
            // Optionally convert string back to BigInt on deserialization
            // (but keeping as string is usually fine for display)
            return value
          },
        }),
        partialize: (state) => {
          // Only persist data, not loading/error states
          const persistedState: Partial<CustomerServiceState> = {}
          {
            const slot = state.listCustomers
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.listCustomers = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ListCustomersResponse>
            }
          }
          {
            const slot = state.createCustomer
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.createCustomer = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<CreateCustomerResponse>
            }
          }
          {
            const slot = state.getCustomer
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.getCustomer = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<GetCustomerResponse>
            }
          }
          {
            const slot = state.updateCustomer
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.updateCustomer = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<UpdateCustomerResponse>
            }
          }
          {
            const slot = state.deleteCustomer
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.deleteCustomer = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<DeleteCustomerResponse>
            }
          }
          {
            const slot = state.activateCustomer
            const persistedByKey = Object.fromEntries(
              Object.entries(slot.byKey ?? {})
                .filter(([, e]) => e?.data !== undefined)
                .map(([k, e]) => [k, { data: e.data, loading: false, error: undefined }])
            )
            if (slot.data !== undefined || Object.keys(persistedByKey).length > 0) {
              persistedState.activateCustomer = {
                data: slot.data,
                loading: false,
                error: undefined,
                byKey: persistedByKey,
              } as MethodState<ActivateCustomerResponse>
            }
          }
          return persistedState
        },
        // Persisted state written before request-keyed caching lacks `byKey`.
        // The default shallow merge replaces each method slot wholesale, which
        // would drop the freshly-initialized `byKey` map and make reads/writes
        // to `byKey[...]` throw. Re-add `byKey` for any rehydrated slot, and
        // surface any legacy top-level `data` under the no-request key so
        // no-arg hooks (the only request shape we can reconstruct) still see it
        // instead of `undefined`. Keyed reads for other requests fall through
        // to a fresh fetch, so we never serve one request's data for another.
        merge: (persisted, current) => {
          const merged = { ...current, ...(persisted as object) } as CustomerServiceState
          for (const slot of Object.values(merged as unknown as Record<string, unknown>)) {
            if (
              slot &&
              typeof slot === "object" &&
              "data" in slot &&
              !("byKey" in (slot as object))
            ) {
              const s = slot as unknown as { data: unknown; byKey: Record<string, unknown> }
              s.byKey =
                s.data !== undefined
                  ? { [requestKey(undefined)]: { data: s.data, loading: false, error: undefined } }
                  : {}
            }
          }
          return merged
        },
      }
    ),
    { name: "CustomerService" }
  )
)
